import React, { useEffect, useState } from 'react';
import ClientAccess from '../../dataAccess/ClientAccess';
import {
  ADD_FAB_BUTTON, ADD_FAB_ICON
} from '../../utilities/generatedClasses';
import ClientListView from './components/ClientListView';
import Icon from '../../components/Icon';
import ToastMessageCard from '../../components/ToastMessageCard';

const Clients = () => {
  // Get Email Subject & Body From Triskele API
  const openMail = (user) => {
    ClientAccess.getEmailData()
      .then((response) => {
        if (!response || !response.data || response.data.length === 0) {
          return;
        }
        let reconnectResponse = response.data.find(item => item.EmailType === 'Reconnect Client');
        let emailBody = reconnectResponse.EmailBody;
        let userFirstName = user.ClientInformationArray[0]["First Name"][0].Value;
        emailBody = emailBody.replace("[ClientName]", userFirstName)
    

        const subject = reconnectResponse.EmailSubject;
        const body = emailBody;
        const to = user ? user.email : '';
        const mailtoLink = `mailto:${encodeURIComponent(to)}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

        window.location.href = mailtoLink;

        
      });
  };

   const openNewClientMail = () => {
    ClientAccess.getEmailData()
      .then((response) => {
        if (!response || !response.data || response.data.length === 0) {
          return;
        }
        let newClientResponse = response.data.find(item => item.EmailType === 'New Client');
      
        const subject = newClientResponse.EmailSubject;
        const body = newClientResponse.EmailBody;
        const mailtoLink = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

        window.location.href = mailtoLink;
      });
  };

  const [clickedData, setClickData] = useState(null);
  const [isDismissed, dismiss] = useState(false);
  const [approveMessageShow, showApproveMessage] = useState(false);

  useEffect(() => {
    ClientAccess.getUserSetup().then((response) => { 
      if(response && response.data && response.data.length > 0){
        const userSetup = response.data[0];
        if(userSetup.ApprovedProvider !== '1'){
          showApproveMessage(true);
        }
      }
    })
  }, []);

  const removeAnyOpenFilter = (e) => {
    setClickData({
      offsetParentClasses: e.target.offsetParent?.classList ?? null,
      classes: e.target.classList ?? null,
      offsetParentId:  e.target.offsetParent?.id ?? null
    });
  };

  return (
    <div onClick={removeAnyOpenFilter} aria-hidden style={{ height: '100%' }}>
      {/* <LogoContainer title="Client List" /> */}
      {!isDismissed && approveMessageShow && (
      <ToastMessageCard
        dismiss={() => dismiss(true)}
        text="Please wait for Triskele to approve your profile. You will receive an email when you can continue Prism set up!" />
      )}
      <ClientListView openMail={openMail} clickedData={clickedData} />
      <div className="bottom-actions">
        <label className={`fab-btn ${ADD_FAB_BUTTON}`} aria-hidden onClick={() => openNewClientMail()}>
          <Icon classNames={`small_size ${ADD_FAB_ICON}`} />
        </label>
      </div>
    </div>
  );
};

export default Clients;
